import { NavTab } from './nav-tab.interface';
import { RoutesApp } from './enums/routes-app.enum';

/**
 * Configuração de tabs para diferentes tipos de usuários
 * Permite fácil personalização e manutenção das navegações
 */

// Tabs para o módulo Student (Aluno): ícone em contorno; preenchido (iconSelected) na aba ativa
export const STUDENT_TABS: NavTab[] = [
  {
    id: 'student-feed',
    label: 'Feed',
    icon: 'newspaper-outline',
    iconSelected: 'newspaper',
    route: RoutesApp.STUDENT_FEED,
    transitionDirection: 'right'
  },
  {
    id: 'student-home',
    label: 'Início',
    icon: 'people-outline',
    iconSelected: 'people',
    route: RoutesApp.STUDENT_TRAINERS,
    transitionDirection: 'right'
  },
  {
    id: 'student-workouts',
    label: 'Treinos',
    icon: 'barbell-outline',
    iconSelected: 'barbell',
    route: RoutesApp.STUDENT_MY_WORKOUTS,
    transitionDirection: 'left'
  },
  {
    id: 'student-chats',
    label: 'Chats',
    icon: 'chatbubbles-outline',
    iconSelected: 'chatbubbles',
    route: RoutesApp.CHAT_LIST,
    transitionDirection: 'left'
  },
  {
    id: 'student-profile',
    label: 'Perfil',
    icon: 'person-outline',
    iconSelected: 'person',
    route: RoutesApp.STUDENT_USER_PROFILE,
    transitionDirection: 'right'
  }
];

// Tabs para o módulo Trainer (Personal): ícone em contorno; preenchido (iconSelected) na aba ativa
export const TRAINER_TABS: NavTab[] = [
  {
    id: 'trainer-feed',
    label: 'Feed',
    icon: 'newspaper-outline',
    iconSelected: 'newspaper',
    route: RoutesApp.TRAINER_FEED,
    transitionDirection: 'right'
  },
  {
    id: 'trainer-dashboard',
    label: 'Início',
    icon: 'grid-outline',
    iconSelected: 'grid',
    route: RoutesApp.TRAINER_DASHBOARD,
    transitionDirection: 'right'
  },
  {
    id: 'trainer-workouts',
    label: 'Treinos',
    icon: 'barbell-outline',
    iconSelected: 'barbell',
    route: RoutesApp.TRAINER_MY_WORKOUTS,
    transitionDirection: 'right'
  },

  {
    id: 'trainer-exercises',
    label: 'Exercícios',
    icon: 'list-outline',
    iconSelected: 'list',
    route: RoutesApp.TRAINER_MANAGE_EXERCISES,
    transitionDirection: 'left'
  },
  {
    id: 'trainer-chats',
    label: 'Alunos',
    icon: 'people-outline',
    iconSelected: 'people',
    route: RoutesApp.TRAINER_STUDENTS,
    transitionDirection: 'right'
  },
  {
    id: 'trainer-settings',
    label: 'Ajustes',
    icon: 'settings-outline',
    iconSelected: 'settings',
    route: RoutesApp.TRAINER_SETTINGS,
    transitionDirection: 'left'
  },
];

// Enum para identificar o tipo de usuário
export enum UserType {
  STUDENT = 'student',
  TRAINER = 'trainer',
  GUEST = 'guest'
}

// Mapeamento de tabs por tipo de usuário
export const TABS_BY_USER_TYPE: Record<UserType, NavTab[]> = {
  [UserType.STUDENT]: STUDENT_TABS,
  [UserType.TRAINER]: TRAINER_TABS,
  [UserType.GUEST]: [] // Usuários não logados não têm tabs
};

